import { AppDispatch, AppState } from '@nxsys/store';
import { agencyActs } from '@nxsys/store/slices/agency/actions';
import { GetAssignmentListParams } from '@nxsys/store/slices/assignment/types';
import { useDispatch, useSelector } from 'react-redux';
import BaseAssignmentListing from './BaseAssignmentListing';
import { assignmentActions } from '@nxsys/store/slices/assignment/reducer/assignmentSlice';
import { employeeActs } from '@nxsys/store/slices/employee/actions';
import { resolveFilterCompanyIds } from '@nxsys/utils/companyScope';

const AgencyAssignmentListing = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { isBureauEmployer, user } = useSelector(
    (state: AppState) => state.appStore,
  );

  const { agencyAssignmentList } = useSelector(
    (state: AppState) => state.agencyStore,
  );

  const handleFetchData = (params: GetAssignmentListParams) => {
    const newParams = { ...params };
    newParams.companyIds = resolveFilterCompanyIds(
      newParams.companyIds,
      isBureauEmployer,
      user?.companyUserIds,
    );

    if (!user?.agencyId?.id) return;

    dispatch(
      agencyActs.getAgencyAssignmentList({
        id: user?.agencyId?.id,
        params: newParams,
      }),
    );
  };

  return (
    <BaseAssignmentListing
      assignmentList={agencyAssignmentList}
      handleFetchData={handleFetchData}
    />
  );
};

const AdminAssignmentListing = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { isBureauEmployer, user } = useSelector(
    (state: AppState) => state.appStore,
  );

  const { assignmentList } = useSelector(
    (state: AppState) => state.assignmentStore,
  );

  const handleFetchData = (params: GetAssignmentListParams) => {
    const newParams = { ...params };
    newParams.companyIds = resolveFilterCompanyIds(
      newParams.companyIds,
      isBureauEmployer,
      user?.companyUserIds,
    );
    dispatch(assignmentActions.getAssignmentList(newParams));
  };

  return (
    <BaseAssignmentListing
      assignmentList={assignmentList}
      handleFetchData={handleFetchData}
    />
  );
};

const EmployeeAssignmentListing = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { user } = useSelector((state: AppState) => state.appStore);

  const { assignmentList } = useSelector(
    (state: AppState) => state.employeeStore,
  );

  const handleFetchData = (params: GetAssignmentListParams) => {
    if (!user?.subcontractorId?.id) return;

    dispatch(
      employeeActs.getAssignmentEmployeeList({
        id: user?.subcontractorId?.id,
        ...params,
      }),
    );
  };

  return (
    <BaseAssignmentListing
      assignmentList={assignmentList}
      handleFetchData={handleFetchData}
    />
  );
};

const AssignmentListing = () => {
  const { isAgency, isEmployee } = useSelector(
    (state: AppState) => state.appStore,
  );

  if (isEmployee) {
    return <EmployeeAssignmentListing />;
  }

  if (isAgency) {
    return <AgencyAssignmentListing />;
  }

  return <AdminAssignmentListing />;
};

export default AssignmentListing;
